
export class ObjectUtil {

  public static isNull(value: Object): boolean {
    return value === undefined || value === null;
  }

  public static isNewModel(value: Object): boolean {
    let id: number = null;
    if (!ObjectUtil.isNull(value)) {
      id = Reflect.get(value, 'id') as number;
    }
    return !this.isPositive(id);
  }

  public static clone(value: Object): any {
    if (ObjectUtil.isNull(value)) {
      return new Object();
    }
    return {...value};
  }

  public static isPositive(value: number): boolean {
    return !ObjectUtil.isNull(value) && value > 0;
  }

}
